function toIsoDate(date) {
  return date.toISOString().slice(0, 10);
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function isIsoDate(value) {
  if (typeof value !== 'string' || !ISO_DATE.test(value)) return false;
  const date = new Date(`${value}T00:00:00.000Z`);
  return !Number.isNaN(date.getTime()) && toIsoDate(date) === value;
}

export function isValidCustomRange(from, to) {
  return isIsoDate(from) && isIsoDate(to) && from <= to;
}

function pad2(value) {
  return String(value).padStart(2, '0');
}

/** `datetime-local` value in the browser's local zone. */
export function toDatetimeLocalValue(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}T${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

export function datetimeLocalToIso(value) {
  if (typeof value !== 'string' || !value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
}

export function isValidCustomDateTimeRange(from, to) {
  const start = datetimeLocalToIso(from);
  const end = datetimeLocalToIso(to);
  return Boolean(start && end && start <= end);
}

export function defaultCustomDateTimeRange() {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - 6);
  from.setHours(0, 0, 0, 0);
  return { from: toDatetimeLocalValue(from), to: toDatetimeLocalValue(to) };
}

export function dateRangeFromDateTimes(fromLocal, toLocal) {
  const fromIso = datetimeLocalToIso(fromLocal);
  const toIso = datetimeLocalToIso(toLocal);
  if (!fromIso || !toIso) return null;
  return { from: fromIso.slice(0, 10), to: toIso.slice(0, 10) };
}

/** Rolling UTC date window ending today (inclusive). */
export function buildRange(days) {
  const to = new Date();
  const from = new Date();
  from.setUTCDate(from.getUTCDate() - (days - 1));
  return { from: toIsoDate(from), to: toIsoDate(to) };
}

/**
 * Prior period of equal length for WoW/MoM-style deltas.
 * @param {{ from: string, to: string }} range ISO date strings YYYY-MM-DD
 */
export function priorPeriodRange(range) {
  const fromDate = new Date(`${range.from}T00:00:00.000Z`);
  const toDate = new Date(`${range.to}T00:00:00.000Z`);
  const lengthDays = Math.max(
    1,
    Math.round((toDate - fromDate) / 86400000) + 1
  );
  const priorTo = new Date(fromDate);
  priorTo.setUTCDate(priorTo.getUTCDate() - 1);
  const priorFrom = new Date(priorTo);
  priorFrom.setUTCDate(priorFrom.getUTCDate() - (lengthDays - 1));

  return { from: toIsoDate(priorFrom), to: toIsoDate(priorTo) };
}
